import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => createStyles({
    icon: {
        pointerEvents: 'none',
        position: 'absolute',
        paddingRight: '16px',
        right: 0,
    },
}));

const ChevronUp: React.FC = (() => {
    const classes = useStyles();

    return (
        <img src="/img/chevronUp.svg" alt="dropdown" className={classes.icon} />
    );
});

export default ChevronUp;
